export const ETAPE = {
  1: 'Intrare – Lead',
  2: 'Client / Intermediar',
  3: 'Dosar / Bancă',
  4: 'Retenție',
};

export const ETAPA_SHORT = {
  1: '1. Lead',
  2: '2. Client',
  3: '3. Dosar',
  4: '4. Retenție',
};

export const STATUS_LABELS = {
  nou: 'Nou',
  contactat: 'Contactat',
  calificat: 'Calificat',
  semnare_documente: 'Semnare documente',
  analiza: 'Analiză',
  simulari_trimise: 'Simulări trimise',
  modificari_cerute: 'Modificări cerute',
  banci_alese: 'Bănci alese',
  in_lucru: 'În lucru',
  credit_activ: 'Credit activ',
  dobanda_fixa_expira_curand: 'Dobândă fixă expiră curând',
  contactat_retentie: 'Contactat pentru retenție',
  renuntat: 'Renunțat',
};

export const STATUS_BY_STAGE = {
  1: ['nou', 'contactat', 'calificat'],
  2: ['semnare_documente', 'analiza', 'simulari_trimise', 'modificari_cerute', 'banci_alese'],
  3: ['in_lucru'],
  4: ['credit_activ', 'dobanda_fixa_expira_curand', 'contactat_retentie'],
};

export const ACTE_LABELS = {
  gdpr: 'GDPR',
  informare: 'Informare client',
  declaratie: 'Declarație client',
  cga: 'CGA',
};

export const CONVERT_LABEL = {
  1: 'Califică → Etapa 2',
  2: 'Bănci alese → Etapa 3',
  3: 'Disbursat → Etapa 4',
};

// ---- Faza 2: dosare la bancă ----
export const DOSAR_STATUS_LABELS = {
  in_pregatire: 'În pregătire',
  depus: 'Depus la bancă',
  preaprobat: 'Preaprobat',
  evaluare: 'Evaluare imobil',
  aprobat_final: 'Aprobat final',
  contractat: 'Contractat / Disbursat',
  respins: 'Respins',
};

export const DOSAR_STATUS_ORDER = [
  'in_pregatire', 'depus', 'preaprobat', 'evaluare', 'aprobat_final', 'contractat', 'respins',
];

export const dosarStatusLabel = (s) => DOSAR_STATUS_LABELS[s] || s || '—';

export const statusLabel = (s) => STATUS_LABELS[s] || s || '—';

// ---- Tabel etape (ecran principal CRM): o coloană per status, pe tot traseul ----
export const BOARD_COLUMNS = [
  { key: 'nou', label: 'Lead nou', etapa: 1 },
  { key: 'contactat', label: 'Contactat', etapa: 1 },
  { key: 'calificat', label: 'Calificat', etapa: 1 },
  { key: 'semnare_documente', label: 'Semnare documente', etapa: 2 },
  { key: 'analiza', label: 'Analiză', etapa: 2 },
  { key: 'simulari_trimise', label: 'Simulări trimise', etapa: 2 },
  { key: 'modificari_cerute', label: 'Modificări cerute', etapa: 2 },
  { key: 'banci_alese', label: 'Bănci alese', etapa: 2 },
  { key: 'in_pregatire', label: 'În pregătire', etapa: 3, dosar: true },
  { key: 'depus', label: 'Depus la bancă', etapa: 3, dosar: true },
  { key: 'preaprobat', label: 'Preaprobat', etapa: 3, dosar: true },
  { key: 'evaluare', label: 'Evaluare imobil', etapa: 3, dosar: true },
  { key: 'aprobat_final', label: 'Aprobat final', etapa: 3, dosar: true },
  { key: 'contractat', label: 'Contractat', etapa: 3, dosar: true },
  { key: 'respins', label: 'Respins', etapa: 3, dosar: true },
  { key: 'credit_activ', label: 'Credit activ', etapa: 4 },
  { key: 'dobanda_fixa_expira_curand', label: 'Dobândă fixă expiră', etapa: 4 },
  { key: 'contactat_retentie', label: 'Contactat retenție', etapa: 4 },
];

export const ETAPA_COLORS = {
  1: { head: 'bg-emerald-50 text-emerald-900 border-emerald-200', cell: 'bg-emerald-500 hover:bg-emerald-600' },
  2: { head: 'bg-amber-50 text-amber-900 border-amber-200', cell: 'bg-amber-400 hover:bg-amber-500' },
  3: { head: 'bg-violet-50 text-violet-900 border-violet-200', cell: 'bg-violet-500 hover:bg-violet-600' },
  4: { head: 'bg-sky-50 text-sky-900 border-sky-200', cell: 'bg-sky-500 hover:bg-sky-600' },
};

/** Coloanele marcate pentru un rând: {key: eticheta din căsuță}. Etapa 3 vine din dosare. */
export const activeCells = (row) => {
  if (row.etapa === 3) {
    const dosare = row.dosare || [];
    if (!dosare.length) return { in_pregatire: 'fără dosar' };
    return dosare.reduce((acc, d) => {
      if (!d.status) return acc;
      acc[d.status] = acc[d.status] ? `${acc[d.status]}, ${d.banca || '—'}` : (d.banca || '—');
      return acc;
    }, {});
  }
  if (!row.status) return {};
  // în retenție se vede banca la care e creditul activ
  if (row.etapa === 4) {
    const banca = row.credit?.banca
      || (row.dosare || []).find((d) => d.status === 'contractat')?.banca
      || '';
    return { [row.status]: banca };
  }
  return { [row.status]: '' };
};

